import React from 'react';
import {fetchContactPage} from '../util/pages';
import ContactForm from '../components/forms/ContactForm';
import SeoTags, {SeoTagsConfig} from '../components/SeoTags';
import {withUserGetServerSideProps} from '../util/util';
import wrapper from '../store/store';
import {Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle} from '@/components/ui/card';
import {Button} from '@/components/ui/button';

type ContactPageProps = {
    content?: {
        seo?: SeoTagsConfig;
    }
}

function ContactPage({content}: ContactPageProps = {}) {
  const formId = React.useId();

  return <>
      <SeoTags config={content?.seo} />
      <div className="flex items-center justify-center my-16">
          <Card className="w-full max-w-screen sm:w-1/2 lg:w-1/3">
              <CardHeader className="space-y-1">
                  <CardTitle className="text-2xl">Contact us</CardTitle>
                  <CardDescription>
                      We will respond to your message as soon as possible.
                  </CardDescription>
              </CardHeader>
              <CardContent className="grid gap-4">
                  <ContactForm formId={formId}/>
              </CardContent>
              <CardFooter>
                  <Button className="w-full" form={formId} type="submit">Send</Button>
              </CardFooter>
          </Card>
      </div>
  </>
}


export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async () => {
    const content = await fetchContactPage();
    return { props: {content} }
}));


export default ContactPage;
